// extracted by mini-css-extract-plugin
module.exports = {"label":"a10a3f92e9--label--fCs_v","cursor_pointer":"a10a3f92e9--cursor_pointer--i71ok"};